export default __webpack_public_path__ + "static/identity-mock-m5-0541c3062948f84caae2ca5b755d9b5d.png";